import { render } from "./20210426.vue?vue&type=template&id=3dafe68a&scoped=true"
import script from "./20210426.vue?vue&type=script&lang=js"
export * from "./20210426.vue?vue&type=script&lang=js"

import "./20210426.vue?vue&type=style&index=0&id=3dafe68a&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-3dafe68a"

export default script